module.exports = __webpack_public_path__ + "img/panthers-logo-sm.be7101d7.png";